__turbopack_context__.v({
  "action": "ImageItem-module-scss-module__EOcOWW__action",
  "card": "ImageItem-module-scss-module__EOcOWW__card",
  "content": "ImageItem-module-scss-module__EOcOWW__content",
  "imageItem": "ImageItem-module-scss-module__EOcOWW__imageItem",
});
